import { shuffle } from "lodash";

export function customShuffle(array, item) {
  let arrayCopy = [...array];
  let randomItem = shuffle(arrayCopy)[0];
  if (randomItem === item) {
    arrayCopy.splice(arrayCopy.indexOf(item), 1);
    randomItem = shuffle(arrayCopy)[0];
  }
  array.splice(array.indexOf(randomItem), 1);
  return [randomItem, array];
}

export function findRequiredArrayForSmartTile(inputRows) {
  let smartTileArray = [];
  let correctAnswerArray = [];
  inputRows.forEach((rowItem) => {
    rowItem.forEach((tileItem) => {
      correctAnswerArray.push(tileItem["topSource"]);
    });
  });
  inputRows.forEach((rowItem) => {
    let rowArray = [];
    rowItem.forEach((tileItem) => {
      const [defautInput, modifiedArray] = customShuffle(
        correctAnswerArray,
        tileItem.topSource
      );
      correctAnswerArray = modifiedArray;
      const smartTile = {
        ControlID: tileItem.ControlID,
        TopSrc: tileItem.TopSrc,
        BottomSrc: tileItem.BottomSrc,
        Weight: tileItem.Weight,
        defaultInput: null,
        CorrectAnswerExplanation: tileItem.CorrectAnswerExplanation,
        IncorrectAnswerExplanation: tileItem.IncorrectAnswerExplanation,
        SequenceHint: tileItem.SequenceHint,
      };
      rowArray.push(smartTile);
    });
    smartTileArray.push(rowArray);
  });
  return smartTileArray;
}

export function twoDimensionShuffle(array, isReset) {
  let singleShuffledArray = [];
  array.forEach((rowItem) => {
    rowItem.forEach((tileItem) => {
      tileItem.defaultInput = tileItem.TopSrc;
      if (isReset) {
        tileItem.disabled = false;
      }
      singleShuffledArray.push(tileItem);
    });
  });
  return shuffle(singleShuffledArray);
}
